

var Utils = {
    sendRequest: function (url, data, options) {
        //url="http://localhost"+url
        if (window.rootPath) {
            url = window.rootPath + url;
        }

        if (window.sid) {
            var prefix = (url.indexOf("?") >= 0) ? "&" : "?"
            url += prefix + "sid=" + window.sid;
        }
        let type = "get";
        if (data && typeof data == "object") {
            type = "post";
            data = JSON.stringify(data);
        }

        return new Promise((resolve, reject) => {

            var xhr = new XMLHttpRequest();

            xhr.open(type, url, true);
            //xhr.withCredentials = true;

            if(options) {
                xhr.setRequestHeader("Content-Type", "application/octet-stream");
            }else{
                xhr.setRequestHeader("Content-Type", "application/json;charset=utf-8");
            }
            xhr.send(data);
            xhr.onreadystatechange = () => {
                if (xhr.readyState == 4) {
                    if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304) {
                        if (xhr.responseText.startsWith("{") || xhr.responseText.startsWith("[")) {
                            var resultObj = JSON.parse(xhr.responseText);
                            resolve(resultObj)

                        } else {
                            resolve(xhr.responseText);
                        }
                    }
                    else {
                        reject(xhr.responseText);
                    }

                }
            }
        })
    },

};



export default Utils;



// WEBPACK FOOTER //
// ./src/common/xhr.js